import React, { useState, useRef, useEffect } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Button, Form, Input, Loader } from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import { Container, Content, Title, Img, Label } from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../../services/auth";

const EditarSimulado = (props) => {
  const id = props.match.params.id;

  const [title, setTitle] = useState(null);
  const [text, setText] = useState(null);
  const [icon, setIcon] = useState(null);
  const [timeToLeave, setTimeToLeave] = useState(null);
  const [url, setUrl] = useState("");

  const sendNotification = async () => {
    const payload = {
      title: title,
      text: text,
      icon: icon,
      url: url,
      timeToLeave: timeToLeave,
    };

    const ValidaFormualrio = await yup.object().shape({
      titulo: yup
        .string("Necessário que informe o titulo")
        .required("Necessário que informe o titulo"),
      text: yup
        .string("Necessário que informe a descrição")
        .required("Necessário que informe a descrição"),
      icon: yup
        .string("Necessário que informe a url do icone")
        .required("Necessário que informe a url do icone "),
      TTL: yup
        .number(
          "Necessário que informe o tempo em segundos que a mensagem ficará para o usuário"
        )
        .required(
          "Necessário que informe o tempo em segundos que a mensagem ficará para o usuário "
        ),
    });

    api.post("/admin/web-push/notification", payload);
  };

  return (
    <>
      <Container>
        <AdminMenu />

        <Content>
          <Title>Enviar Notificações</Title>

          <Form>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Título da Mensagem"
                placeholder="Título da Mensagem"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Texto da Mensagem"
                placeholder="Texto da Mensagem"
                value={text}
                onChange={(e) => {
                  setText(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Link da Imagem"
                placeholder="Link Icone que acompanhará a mensagem"
                value={icon}
                onChange={(e) => {
                  setIcon(e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="URL de Redirecionamento"
                placeholder="URL de Redirecionamento"
                value={`https://voitto.com.br/${url}`}
                onChange={(e) => {
                  setUrl(e.target.value.replace("https://voitto.com.br/", ""));
                }}
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Field
                control={Input}
                label="Tempo até sair das notificações (Time to Leave)"
                placeholder="Tempo que a mensagem ficarádisponível para o usuário"
                value={timeToLeave}
                onChange={(e) => {
                  setTimeToLeave(e.target.value);
                }}
              />
            </Form.Group>
            <h3>
              Caso precise fazer o upload uma imagem clique
              <a href={"https://voitto.com.br/upload/anexos"} target={"_blank"}>
                {" "}
                aqui
              </a>
            </h3>
            <Form.Group>
              <Form.Field
                control={Button}
                onClick={() => {
                  sendNotification();
                }}
              >
                Enviar
              </Form.Field>
            </Form.Group>
          </Form>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EditarSimulado);
